import Vue from 'vue';
import axios from 'axios';
import LoadScript from 'vue-plugin-load-script';
import { sync } from 'vuex-router-sync';
import skeleton from 'tb-skeleton';
import App from './App';
import router from './router';
import store from './store';
import i18n from './i18n';
import helpers from './helpers';
import VueSweetalert2 from 'vue-sweetalert2';

import { BootstrapVue } from 'bootstrap-vue';
Vue.use(BootstrapVue);

Vue.config.productionTip = false;
Vue.use(LoadScript);
Vue.use(skeleton);

const options = {
  customClass: {
    closeButton: 'dialog-close',
    cancelButton: 'dialog-cancel',
    confirmButton: 'dialog-confirm',
    //content: '...',
    //htmlContainer: '...',
  }
};
Vue.use(VueSweetalert2, options);

sync(store, router);

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.BASE_URL;

Vue.prototype.$http = axios;
Vue.prototype.$http.defaults.headers.common['Content-Language'] = i18n.locale;
const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
}

Vue.loadScript('/static/vendor/jQuery/jquery-3.5.1.min.js').then(() => {
  Vue.loadScript('/static/vendor/popper.min.js').then(() => {
    Vue.loadScript('/static/vendor/bootstrap-4.5.3-dist/js/bootstrap.min.js');
    Vue.loadScript('/static/js/script.js');
    Vue.loadScript('/static/js/select.js');
  });
});

Vue.prototype.helpers = helpers;

import Echo from 'laravel-echo';
window.Pusher = require('pusher-js');
// window.Pusher.logToConsole = true;

// window.Echo = new Echo({
//   broadcaster: 'pusher',
//   key: '68ff0c7078cb36bce3e3',
//   wsHost: 'api.my.ug.edu.ge',
//   wsPort: 6001,
//   wssPort: 6001,
//   forceTLS: false,
//   disableStats: true,
//   auth: {
//     headers: {
//       Authorization: 'Bearer ' + token
//     },
//   },
//   encrypted: false,
//   enabledTransports: ['ws', 'wss'],
//   authEndpoint : axios.defaults.baseURL + 'api/broadcasting/auth',
// });

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: '68ff0c7078cb36bce3e3',
  wsHost: 'api.my.ug.edu.ge',
  wsPort: 8080,
  wssPort: 8080,
  forceTLS: true,
  encrypted: true,
  disableStats: true,
  enabledTransports: ['ws', 'wss'],
  auth: {
    headers: {
      Authorization: 'Bearer ' + token
    },
  },
  authEndpoint : axios.defaults.baseURL + 'api/broadcasting/auth',
});

new Vue({
  el: '#app',
  functional: true,
  router,
  store,
  i18n,
  render(h) {
    return h(App);
  },
});



// WEBPACK FOOTER //
// ./src/main.js